<template>
  <div>
    <MoveModal
        :visible="moveModal.visible"
        :nestedFolders="foldersForMoveModal"
        :channelId="channelId"
        @close="closeMoveModal"
        @move="moveFolder"
        ref="moveModal"
    ></MoveModal>
    <article class="content listed file">
      <i class="fal fa-file-image file-type icon"   v-on:click="this.$emit('perform', 'goToContent', this.content);" </i>
      <div class="title file-name" v-if="!isSharedFromAnotherRally"  v-on:click="this.$emit('perform', 'goToContent', this.content);"> 
        {{ content.attributes.title }}
      </div>
      <div v-if="isSharedFromAnotherRally" v-on:click="this.$emit('perform', 'goToContent', this.content);" class="shared-title">
        {{
          content.attributes.title
        }} <span class="shared">(SHARED by {{sharedByName}})</span>
      </div>
      <div class="author-name">
        {{ byLine }}
      </div>
      <div v-if="!stillLoading" class="other-info">
        {{ Math.round(content.attributes["file-size"]/1000) + " KB"}} |
        {{ formatDate(content.attributes["created-at"]) }}
      </div>
      <div v-if="stillLoading" class="other-info">
        <i class="fas fa-spinner fa-spin"></i>
      </div>
      <ContentPin :content="content"/>
      <ContentElipsisMenu @moveFile="openMoveModal" :content="content" :rallyId="this.rallyId"
                          :channelId="this.channelId" contentType="Files" canDownload="true" canShare="true"
                          canMove="true" hideSentiments="true" :contextShare="contextShare"/>

    </article>
  </div>
</template>

<script>
  import BinaryMixin from "../../BinaryMixin";
  import ContentMixin from "../../ContentMixin";
  import MoveModal from "@/components/content/folder/MoveModal.vue";
  import {mapActions, mapState, mapGetters} from "vuex";
  import { LocalNotifications } from '@capacitor/local-notifications';
  import { Browser } from "@capacitor/browser";
  import { router} from "../../../common";
  

export default {
  name: "File",
  components: {MoveModal},
  mixins: [
    BinaryMixin,
    ContentMixin,
  ],
  data() { 
    return {
      moveModal: {
        visible: false,
        selectedFolderId: null
      }
    }
  },
  props: {
    channel: Object,
    rally: Object,
    content: Object,
    contextShare: Object,
    parentContextId:String
  },
  computed: {
    ...mapState("contents", ["allContentByContextTypeAndId"]),
    ...mapGetters("contents", ["folderStructureByChannel"]),

    stillLoading(){
      return Math.round(this.content.attributes['file-size']/1000) == 0
    },

    // Get cached folder structure from store
    folderList() {
      return this.folderStructureByChannel(this.channelId) || [];
    },

foldersForMoveModal() {
  const foldersById = {};
  const topLevelFolders = [];

  const clonedFolders = this.folderList.map(folder => ({
    ...folder,
    children: [],
    attributes: {
      ...folder.attributes,
      'nest-level': folder.attributes['nest-level'] || 1
    }
  }));

  for (const folder of clonedFolders) {
    foldersById[folder.id] = folder;
  }

  for (const folder of clonedFolders) {
    if (folder.parentId && foldersById[folder.parentId]) {
      const parent = foldersById[folder.parentId];
      folder.attributes['nest-level'] = parent.attributes['nest-level'] + 1;
      parent.children.push(folder);
    } else {
      topLevelFolders.push(folder);
    }
  }

  // Add synthetic root
  topLevelFolders.unshift({
    id: this.channelId,
    children: [],
    attributes: {
      editable: true,
      type: 'RootFolder',
      title: '** HOME **'
    }
  });

  return topLevelFolders;
},

    
    contentsFolders() {
      return this.allContentByContextTypeAndId[parseInt(this.parentContextId)];
    },

    filteredContentsFolders(){
      const cs = this.contentsFolders;
      if (cs && cs.length > 0){
        return cs.filter(function(s) {
          return !(s.attributes && s.attributes.title && s.attributes.title.indexOf('[untitled]') >= 0 ) &&
              (s.attributes['status'] == 1 ||
                  s.attributes['status'] == 2 ||
                  s.attributes['status'] == 0 ||
                  s.editMode == true || s.attributes['lifecycle'] == "new")
        })
      } else {
        return []
      }
    }
  },
  mounted() {
    // No need to fetch folders here anymore - they're already in the store
    // Just ensure we have the folder structure
    if (this.folderList.length === 0) {
      console.log('Folder structure not yet loaded, will be loaded by parent component');
    }
  },
  methods: {
    ...mapActions("contents", ["moveContent"]),

    move(params) {
      // Emit an event to notify the parent component about the move action 
      this.$emit('perform', 'moveFolder', params);
    },
    openLink(url) {
      Browser.open({ url: url });
    },
    openMoveModal() {
      this.moveModal.visible = true;
    },
    closeMoveModal() {
      this.moveModal.visible = false;
    },
    /*goToContent() {
      const currentPath = this.$route.path;
      if (currentPath.indexOf("/f/") < 0){
        router.push(`${currentPath}/f/${this.content.id}`);
      } else {
        router.push(`${currentPath}/${this.content.id}`);
      }
      //this.$emit('perform', 'openContainer', this.content);
    },*/
    async moveFolder(params) {
      // Handle the logic for moving the folder
      await this.moveContent({shareId: this.contextShare.id, destinationId: params.destinationFolderId, destinationType: params.contextType})
      this.$store.dispatch('user/flashSuccess', 'File successfully moved!');
      this.closeMoveModal()
      window.location.reload();
    }
  },
};
</script>